module.exports = {
	"header": "70 brands on board - now the startup is valued at 150 million",
	"date": "2021/06/17",
	"imgSrc": "8.jpg",
	"imgAlt": "70 brands on board - now the startup is valued at 150 million",
	"ingress": "By: Ehandel.se (in Swedish)",
	"externalLink": "https://www.ehandel.se/70-varumarken-ombord-nu-varderas-startupen-till-150-miljoner"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/8/article.json
// module id = 98
// module chunks = 0